import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Home from '../Home';
import { requestVendor, updateDimensions, updateScroll } from '../../actions';

const mapStateToProps = state => ({
  color: state.color,
  styles: state.styles,
  constants: state.constants,
  dimensions: state.dimensions,
  scroll: state.scroll,
  text: state.text,
  vendor: state.vendor
});

const mapDispatchToProps = dispatch => ({
  requestVendor: name => {
    dispatch(requestVendor(name));
  },
  updateDimensions: dimensions => {
    dispatch(updateDimensions(dimensions));
  },
  updateScroll: scroll => {
    dispatch(updateScroll(scroll));
  },
  redirect: route => {
    dispatch(push(route));
  }
});

const HomePage = connect(mapStateToProps, mapDispatchToProps)(Home);

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage/index.js